<template>
    <div>
        <app-title text="PQR's Resueltas" />
        <app-petition-filters
            @filter="onFilter"
            :is-assigned="false"
            :is-resolved="true"
        />
        <app-table-resolved-petitions
            :data="data"
            :on-change-page="onChangePage"
            :see-comments-by-petition="seeCommentsByPetition"
            :see-more="seeMore"
            :start-add-comment="startAddComment"
            :start-approve="startApprove"
            :start-reject-petition="startRejectPetition"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up
            title="Comentarios de la petición"
            size="large"
            id="view-comments-petition-resolved-petitions"
        >
            <div class="body" slot="body">
                <app-petition-comments-list
                    :withActions="false"
                    :comments="commentsPetitionSelect"
                />
            </div>
        </app-pop-up>

        <app-pop-up id="view-petition-more-resolved-petitions" title="Petición">
            <div slot="body">
                <div class="row">
                    <div class="col-6">
                        <h5>Fecha de creación</h5>
                        <label>{{ petitionView.date | datetime }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Tipo de petición</h5>
                        <label>{{ petitionView.type }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Cliente</h5>
                        <label>{{ petitionView.client }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuario</h5>
                        <label>{{ petitionView.user }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Estado</h5>
                        <label>{{ petitionView.status }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Clasificación</h5>
                        <label>{{ petitionView.rating }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuarios asignados</h5>
                        <div v-if="petitionView.assignments">
                            <div v-for="assignment in petitionView.assignments">
                                {{
                                    assignment.inactive
                                        ? assignment.user.name
                                        : assignment.user.name +
                                          ' (Actualmente)'
                                }}
                            </div>
                        </div>
                        <div v-if="!petitionView.assignments.length">
                            No tiene
                        </div>
                    </div>
                </div>
                <br />
                <h5 style="text-align:center">
                    <label for="anotation">Descripción</label>
                </h5>
                <textarea
                    type="text"
                    id="anotation"
                    class="form-control"
                    disabled="true"
                    cols="80"
                    rows="8"
                    v-model="petitionView.description"
                ></textarea>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Aprobación de petición"
            id="approve-petition-resolved-petitions"
            :onClose="cleanFormApprove"
        >
            <div class="body" slot="body">
                <h5>¿Esta seguro que desea aprobar esta petición?</h5>
                <app-form-textarea-input
                    label="Resolución"
                    v-model="approvePetition.resolution"
                    :required="true"
                    :hasError="$v.approvePetition.resolution.$error"
                    errorMessage="Debe escribir la solución de la petición"
                />
                <app-upload-files
                    id="petition-files"
                    title="Adjunte solución de la petición"
                    v-model="approvePetition.files"
                ></app-upload-files>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="approve(approvePetition)"
                    :disabled="inProgress"
                >
                    Aprobar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Rechazo de petición"
            id="reject-petition-resolved-petitions"
            :onClose="cleanFormReject"
        >
            <div class="body" slot="body">
                <h5>¿Está seguro que desea rechazar la solución de esta petición?</h5>
                <app-form-textarea-input
                    label="Motivo del rechazo"
                    v-model="rejectForm.description"
                    :required="true"
                    :hasError="$v.rejectForm.description.$error"
                    errorMessage="Debe indicar el motivo del rechazo"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="reject(rejectPetition)"
                    :disabled="inProgress"
                >
                    Rechazar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Agregar comentario a la petición"
            id="petition-comment-resolved-petitions"
            :onClose="cleanFormComment"
        >
            <div class="body" slot="body">
                <app-add-petition-comment
                    id="petition-comment-resolved-petitions"
                    :petition="petitionComment"
                    :on-save="onSaveComment"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="
                        $bus.$emit('petition-comment-resolved-petitions.save')
                    "
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import petitionsRepository from '../../../repositories/petitions.repository.js'
import AddPetitionComment from '../PetitionComment/AddPetitionComment.vue'
import { required } from 'vuelidate/lib/validators'
import Title from '../../UI/Layout/Title.vue'
import UploadFiles from '../../UI/Controls/Files/UploadFiles.vue'
import TableResolvedPetitions from './TableResolvedPetitions/TableResolvedPetitions.vue'
import PetitionFilters from '../PetitionFilters/PetitionFilters.vue'
import PetitionCommentsList from '../PetitionComment/PetitionCommentsList'

export default {
    components: {
        appAddPetitionComment: AddPetitionComment,
        appUploadFiles: UploadFiles,
        appTableResolvedPetitions: TableResolvedPetitions,
        appPetitionFilters: PetitionFilters,
        appPetitionCommentsList: PetitionCommentsList,
    },

    data() {
        return {
            petitionView: {
                user: '',
                client: '',
                type: '',
                date: '',
                description: '',
                status: '',
                rating: '',
                assignments: [],
            },
            commentsPetitionSelect: [],
            data: {},
            petitionComment: {},
            approvePetition: {
                resolution: '',
                files: '',
                id: '',
            },
            rejectPetition: {},
            rejectForm: {
                description: '',
            },
            page: 1,
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc',
            },
            filters: {},
        }
    },

    validations: {
        approvePetition: {
            resolution: { required },
        },
        rejectForm: {
            description: { required },
        },
    },

    methods: {
        loadPetitions() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            const pr = Object.assign({}, petitionsRepository)
            pr.loadPetitionsResolved(filters, this.page)
                .then(data => {
                    this.data = data
                })
                .catch(error =>
                    toastr.error('Error al cargar las peticiones pendientes')
                )
        },
        onChangePage(page) {
            this.page = page
            this.loadPetitions()
        },
        seeMore(petition) {
            Object.keys(this.petitionView).map(
                key => (this.petitionView[key] = '')
            )
            this.petitionView.user = petition.user.name
            this.petitionView.client = petition.client.name
            this.petitionView.type = petition.petition_type.name
            this.petitionView.date = petition.created_at
            this.petitionView.description = petition.description
            this.petitionView.status = petition.petition_status.name
            this.petitionView.rating = petition.petition_rating
                ? petition.petition_rating.name
                : 'Sin clasificación'
            this.petitionView.assignments = petition.petition_assignment

            this.$bus.$emit('view-petition-more-resolved-petitions.open')
        },
        seeCommentsByPetition(petition) {
            this.commentsPetitionSelect = petition.comments
            this.$bus.$emit('view-comments-petition-resolved-petitions.open')
        },
        startAddComment(petition) {
            this.petitionComment = petition
            this.$bus.$emit('petition-comment-resolved-petitions.open')
        },
        onSaveComment() {
            this.$bus.$emit('petition-comment-resolved-petitions.close')
            this.loadPetitions()
        },
        cleanFormComment() {
            this.$bus.$emit('petition-comment-resolved-petitions.clean')
        },
        startApprove(petition) {
            this.approvePetition.id = petition.id
            this.$bus.$emit('approve-petition-resolved-petitions.open')
        },
        startRejectPetition(petition) {
            this.rejectPetition = petition
            this.rejectForm.description = ''
            this.$v.rejectForm && this.$v.rejectForm.$reset()
            this.$bus.$emit('reject-petition-resolved-petitions.open')
        },
        approve() {
            this.$v.approvePetition.$touch()
            if (this.$v.approvePetition.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const formData = new FormData()
            formData.append('userId', this.user.id)
            formData.append('resolution', this.approvePetition.resolution)

            if (this.approvePetition.files.files) {
                this.approvePetition.files.files.map((item, index) =>
                    formData.append('file' + index, item)
                )
            }
            const pr = Object.assign({}, petitionsRepository)

            pr.approvePetitionByCompany(this.approvePetition.id, formData)
                .then(data => {
                    this.cleanFormApprove()
                    this.$bus.$emit('approve-petition-resolved-petitions.close')
                    this.loadPetitions()
                    toastr.success('Petición aprobada correctamente')
                })
                .catch(error => {
                    toastr.error('No fue posible aprobar la petición')
                })
        },
        reject() {
            this.$v.rejectForm.$touch()
            if (this.$v.rejectForm.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const formData = new FormData()
            formData.append('userId', this.user.id)
            formData.append('description', this.rejectForm.description.trim())
            const pr = Object.assign({}, petitionsRepository)

            pr.rejectPetitionByCompany(this.rejectPetition.id, formData)
                .then(data => {
                    this.cleanFormReject()
                    this.$bus.$emit('reject-petition-resolved-petitions.close')
                    this.loadPetitions()
                    this.$bus.$emit('loadNotifications')
                    toastr.success('Petición rechazada correctamente')
                })
                .catch(error => {
                    toastr.error('No fue posible rechazar la petición')
                })
        },
        cleanFormApprove() {
            Object.keys(this.approvePetition).map(
                key => (this.approvePetition[key] = '')
            )
        },
        cleanFormReject() {
            this.rejectPetition = {}
            this.rejectForm.description = ''
            this.$v.rejectForm && this.$v.rejectForm.$reset()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadPetitions()
        },
        onFilter(filters) {
            this.filters = filters
            this.loadPetitions()
        },
    },

    created() {
        this.loadPetitions()
    },
    mounted() {
        this.$bus.$on('loadPetitions', this.loadPetitions)
    },
}
</script>
